Object.defineProperty(exports,"__esModule",{value:true});var Platform={OS:'web',select:function select(obj){return'web'in obj?obj.web:obj.default;}};exports.default=Platform;


// WEBPACK FOOTER //
// ./node_modules/react-native-web/dist/apis/Platform/index.js